import React from 'react';
import  { useState, useRef, useCallback } from 'react';
import  { useEffect, useMemo }from 'react';

import { useNavigate } from "react-router-dom";

import './BijeleStranice.css'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { componentStyles } from '../services/elementDesign'
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';


import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Unstable_Grid2';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Modal from '@mui/material/Modal';
import { useHistory, useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from "./redux/actions"

import { DataGrid } from '@mui/x-data-grid';


import { APICall } from './services/api.service';




import Fab from '@mui/material/Fab';
import { useSelector, useDispatch } from 'react-redux';


import { AllCommunityModule } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";

import {
    ClientSideRowModelModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    ModuleRegistry,
    ValidationModule,
    createGrid,
    themeQuartz,
    themeBalham,


    RowSelectionModule,


  } from "ag-grid-community";
import { AiOutlineConsoleSql } from 'react-icons/ai';
import { DiDart } from 'react-icons/di';
  


import { RowApiModule } from 'ag-grid-community'; 
import useDebouncedClick from "./useDebouncedClick";


  ModuleRegistry.registerModules([
    RowSelectionModule,
    ClientSideRowModelModule,


    ValidationModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    RowApiModule
   
  ]);



  const myTheme = themeBalham.withParams({
    headerHeight: "30px",
    headerTextColor: "black",
    headerBackgroundColor: "#99ABCD",
    headerCellHoverBackgroundColor: "rgba(80, 40, 140, 0.66)",
    headerCellMovingBackgroundColor: "rgb(80, 40, 140)",
    //selectedRowBackgroundColor: 'rgba(0, 255, 0, 0.1)',
    selectedRowBackgroundColor: '#8386a6'
  });
  






const theme = createTheme({
    palette: {
        primary: {
            main: '#520074'
        }
    },
    mixins: {
        MuiDataGrid: {
          // Pinned columns sections
          pinnedBackground: '#520074',
          // Headers, and top & bottom fixed rows
          containerBackground: 'primary',
        },
      },

});











function Analiza(props) {
   


    const gridRef = useRef();
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);



    const autoSizeStrategy = useMemo(() => {
        return {
          type: "fitCellContents",
          skipHeader : true
        };
      }, []);

      const autoSizeAll = useCallback((skipHeader) => {
        const allColumnIds = [];
        gridRef.current.api.getColumns().forEach((column) => {
          allColumnIds.push(column.getId());
        });
        gridRef.current.api.autoSizeColumns(allColumnIds, skipHeader);
      }, []);


      const onGridReady = useCallback((event) => {
        console.log("Grid ready *********************************************************************************")
        let nodes = event.api.getRenderedNodes();
        autoSizeAll();
        if (nodes.length) {
          //nodes[0].setSelected(true); //selects the first row in the rendered view
          //nodes[1].setSelected(true);
        }
      }, []);

      const selectAll = useCallback((event) =>{
            console.log("I wanna select it all!!!!!");

            event.api.selectAll();
            console.log("Selected");
      }, []);

      const onColumnResized = useCallback((params) => {
        //console.log(params);
      }, []);

      const themeAG = useMemo(() => {
        return myTheme;
      }, []);
    
      const onRowSelected = useCallback((event) => {

      }, []);
    
      const onSelectionChanged = useCallback((event) => {
        const rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, " + rowCount + " rows selected");
      
      }, []);


 


      const gridRef_jn = useRef();
      const containerStyle_jn = useMemo(() => ({ width: "100%", height: "100%" }), []);
      const gridStyle_jn = useMemo(() => ({ height: "100%", width: "100%" }), []);
  
  
  
      const autoSizeStrategy_jn = useMemo(() => {
          return {
            type: "fitCellContents",
            skipHeader : true
          };
        }, []);
  
        const autoSizeAll_jn = useCallback((skipHeader) => {
          const allColumnIds = [];
          gridRef_jn.current.api.getColumns().forEach((column) => {
            allColumnIds.push(column.getId());
          });
          gridRef_jn.current.api.autoSizeColumns(allColumnIds, skipHeader);
        }, []);
  
  
        const onGridReady_jn = useCallback((event) => {
          console.log("Grid ready *********************************************************************************")
          let nodes = event.api.getRenderedNodes();
          autoSizeAll_jn();
          if (nodes.length) {
            //nodes[0].setSelected(true); //selects the first row in the rendered view
            //nodes[1].setSelected(true);
          }
        }, []);
  
        const selectAll_jn = useCallback((event) =>{
              console.log("I wanna select it all!!!!!");
  
              event.api.selectAll();
              console.log("Selected");
        }, []);
  
        const onColumnResized_jn = useCallback((params) => {
          console.log(params);
        }, []);
  

      
        const onRowSelected_jn = useCallback((event) => {
  
        }, []);
      
        const onSelectionChanged_jn = useCallback((event) => {
          const rowCount = event.api.getSelectedNodes().length;
          console.log("selection changed, " + rowCount + " rows selected");
        
        }, []);
  




        const gridRef_bz = useRef();
        const containerStyle_bz = useMemo(() => ({ width: "100%", height: "100%" }), []);
        const gridStyle_bz = useMemo(() => ({ height: "100%", width: "100%" }), []);
    
    
    
        const autoSizeStrategy_bz = useMemo(() => {
            return {
              type: "fitCellContents",
              skipHeader : true
            };
          }, []);
    
          const autoSizeAll_bz = useCallback((skipHeader) => {
            const allColumnIds = [];
            gridRef_bz.current.api.getColumns().forEach((column) => {
              allColumnIds.push(column.getId());
            });
            gridRef_bz.current.api.autoSizeColumns(allColumnIds, skipHeader);
          }, []);
    
    
          const onGridReady_bz = useCallback((event) => {
            console.log("Grid ready *********************************************************************************")
            let nodes = event.api.getRenderedNodes();
            autoSizeAll_bz();
            if (nodes.length) {
              //nodes[0].setSelected(true); //selects the first row in the rendered view
              //nodes[1].setSelected(true);
            }
          }, []);
    
          const selectAll_bz = useCallback((event) =>{
                console.log("I wanna select it all!!!!!");
    
                event.api.selectAll();
                console.log("Selected");
          }, []);
    
          const onColumnResized_bz = useCallback((params) => {
            console.log(params);
          }, []);
    
  
        
          const onRowSelected_bz = useCallback((event) => {
    
          }, []);
        
          const onSelectionChanged_bz = useCallback((event) => {
            const rowCount = event.api.getSelectedNodes().length;
            console.log("selection changed, " + rowCount + " rows selected");
          
          }, []);



 
          
          const gridRef_arh = useRef();
          const containerStyle_arh = useMemo(() => ({ width: "100%", height: "100%" }), []);
          const gridStyle_arh = useMemo(() => ({ height: "100%", width: "100%" }), []);
      
      
      
          const autoSizeStrategy_arh = useMemo(() => {
              return {
                type: "fitCellContents",
                skipHeader : true
              };
            }, []);
      
            const autoSizeAll_arh = useCallback((skipHeader) => {
              const allColumnIds = [];
              gridRef_arh.current.api.getColumns().forEach((column) => {
                allColumnIds.push(column.getId());
              });
              gridRef_arh.current.api.autoSizeColumns(allColumnIds, skipHeader);
            }, []);
      
      
            const onGridReady_arh = useCallback((event) => {
              console.log("Grid ready *********************************************************************************")
              let nodes = event.api.getRenderedNodes();
              autoSizeAll_arh();
              if (nodes.length) {
                //nodes[0].setSelected(true); //selects the first row in the rendered view
                //nodes[1].setSelected(true);
              }
            }, []);
      
            const selectAll_arh = useCallback((event) =>{
                  console.log("I wanna select it all!!!!!");
      
                  event.api.selectAll();
                  console.log("Selected");
            }, []);
      
            const onColumnResized_arh = useCallback((params) => {
              console.log(params);
            }, []);
      
    
          
            const onRowSelected_arh = useCallback((event) => {
      
            }, []);
          
            const onSelectionChanged_arh = useCallback((event) => {
              const rowCount = event.api.getSelectedNodes().length;
              console.log("selection changed, " + rowCount + " rows selected");
            
            }, []);

/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/*************************************STATE VARIJABLE**************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */


      const [posiljkeList, setPosiljkeList] = useState([],[]);

      const [journalList, setJournalList] = useState([],[]);

      const [arhivaList, setArhivaList] = useState([],[]);

      const [bzList, setBZList] = useState([],[]);

      const [bureInfo, setBureInfo] = useState(''); 



    const [curr_time, setCurrTime] = useState('');

    const navigate = useNavigate();

    const token = localStorage.getItem("token");

    //const { user: currentUser } = useSelector((state) => state.auth);
    const user = localStorage.getItem("user");
    const username = localStorage.getItem("username");
    const ref = localStorage.getItem("id");




    const dispatch = useDispatch()

    const [isDragging, setIsDragging] = useState(false)
    const [modalPosition, setModalPosition] = useState({x:0,y:0})
    const startPosition = useRef({x:0,y:0})
    const popupRef = useRef(null)
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const isMenuOpen = useSelector(store=>store.menu?store.menu.open:false)


    const [tel, setTel] = useState('');
    const [currentInfo, setCurrentInfo] = useState([],[]);
    const [dataCurrent, setDataCurrent] = useState([]);

    const [tableZB, setTableZB] = useState([]);
    const [tableJN, setTableJN] = useState([]);


    
    const [tablePosiljke, setTablePosiljke] = useState([]);


    const toastError = {                                                        
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
   };

   const toastSuccess = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };

   const toastInfo = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };


    useEffect(() => {




    console.log("props", props)
        let tmp = new Date();
    
        console.log(tmp);
    
        tmp.setMinutes(tmp.getMinutes() - 25);
    
        console.log(tmp);
    
        let timeNow = tmp.getDate() + "." + (tmp.getMonth() + 1) + "." + " " + tmp.getHours() + ":" + tmp.getMinutes();
    
        console.log(timeNow);
    
        
        setCurrTime(timeNow);
    
    
    }, []);

  useEffect(()=>{
          document.title="Analiza"
  },[])

  const getAnalizaTel = (tel) => {
    APICall("/GetAnalizaTel", {

        platform: '0',
        version:'1.0',

        tel: tel,
        ref:ref

    }, {
        token
    }).then(response=>{
        
        console.log(response);

        if(response.status !== 200) {

            if(response.status == 401){

                console.log("Istekla sesija");

                toast.error(response.data.message, toastError);
                
                dispatch(actions.logOut());
                navigate('/');

        } else{

                toast.error(response.data.message, toastError);

                

        }


        } else {
            console.log("Response je ok!");

            console.log(response.data);

            if(response.data.info1 && response.data.info1.length!=0){
                
                let dataTmp = response.data;

                //setDataCurrent(dataTmp.info1);


                let tmpBure = dataTmp.info1[0];


                let mj = '';
                let adr = '';
                let pt = '';
    

                if(tmpBure.Mjesto && tmpBure.Mjesto!=''){

                    mj = tmpBure.Mjesto;

                }
                if(tmpBure.Ulica && tmpBure.Ulica!=''){

                    adr = tmpBure.Ulica;

                }
                if(tmpBure.KBR && tmpBure.KBR!=''){

                    adr = adr + ' ' + tmpBure.KBR;

                }                                
                if(tmpBure.PTT && tmpBure.PTT!=''){

                    pt = tmpBure.PTT;

                }
                if(tmpBure.KBR_slovo && tmpBure.KBR_slovo!=''){
                    adr = adr + tmpBure.KBR_slovo;
                }

                let tmpNaziv = tmpBure.Naziv?tmpBure.Naziv:'';

                let tmpNaziv2 = tmpBure.Naziv2?tmpBure.Naziv2:'';

                tmpNaziv = tmpNaziv + " " + tmpNaziv2;

                let tmpTip = tmpBure.Tip?tmpBure.Tip:'';

                let tmpOper = tmpBure.Operator?tmpBure.Operator:'';

                setBureInfo("" + tmpNaziv + " --- " + mj + " --- " + adr + " --- " + pt +   
                    " --- "  + tmpTip + 
                    " --- " + tmpOper
                );



           
                }else{

                    setBureInfo('Telefon ne postoji u buretu')

                }


                if(response.data.info2 && response.data.info2.length!=0){
                  
    
                    let dataTmp = response.data;
        
    
                    let columns= Object.getOwnPropertyNames(dataTmp.info2[0]).map((column,index)=>{
                        var a = column.charAt(0).toUpperCase() + column.slice(1)
                            return(
                                {
                                    "field": column,
                                    "getRowId": index
                                }
                            )
                        })





                        let rows =dataTmp.info2.map((item, index)=> {
                            return({...item,id:index})
                        })
    
    
                        setBZList({
                            columns,
                            rows
                        })

                        console.log("Set the bz");

                        //setTableZB(dataTmp.info2);
    

               
                    }else{
    
                                  setBZList([],[])              
    
                    }

                    if(response.data.info3 && response.data.info3.length!=0){
                        var dataTmp = response.data;
        
    
                        let columns= Object.getOwnPropertyNames(dataTmp.info3[0]).map((column,index)=>{
                            var a = column.charAt(0).toUpperCase() + column.slice(1)
                                return(
                                    {
                                        "field": column,
                                        "getRowId": index
                                    }
                                )
                            })
                            let rows =dataTmp.info3.map((item, index)=> {
                                return({...item,id:index})
                            })
        
               const updatedColumns = columns.map((col) => {


                    if(col.field == 'jn_datetime'){
                      console.log("Gotten datetineeeeeee");
                      console.log(col);

                      return {
                          ...col,
                          valueFormatter: ({ value }) => {
                            if (value) {
                              
                             
                              let date = new Date(value);


                              //return date.toLocaleDateString("DD.MM.YYYY"); // Format as MM/DD/YYYY (or customize)
                              const options = {
                               
                                  year: "numeric",
                                  month: "numeric",
                                  day: "numeric",
                                };
                                return date.toLocaleDateString("hr-HR", options);
                              
                             
                            }
                            return value;
                          },
                          sortComparator: (v1, v2) => {
                            const date1 = new Date(v1);
                            const date2 = new Date(v2);
                            return date1 - date2; // Compare dates
                          },
                        };
                      

                    }



                    return col;
              });


                  //columns = updatedColumns;
                columns =  [
                    ...updatedColumns
                ];
                
                
                            setJournalList({
                                columns,
                                rows
                            })

                            console.log("Set the journalList");
                 
        
                        //setTableJN(dataTmp.info3);
        
    
                   
                        }else{
        
                            setJournalList([],[]);
        
                        }



                        if(response.data.info4 && response.data.info4.length!=0){
                            var dataTmp = response.data;
            
                            
            
            
            
            
                            let columns= Object.getOwnPropertyNames(dataTmp.info4[0]).map((column,index)=>{
                                    return(
                                        {
                                            "field": column,
                                            "getRowId": index
                                        }
                                    )
                                })
                                let rows =dataTmp.info4.map((item, index)=> {
                                    return({...item,id:index})
                                })

                                
                                               const updatedColumns = columns.map((col) => {

                  

                    return col;
              });


                  //columns = updatedColumns;
                columns =  [
                    ...updatedColumns
                ];
            
                                setPosiljkeList({
                                    columns,
                                    rows
                                })

                                console.log("Set the posiljkeList");
                              
            
            
            
            
                       
                            }else{
            
                                    setPosiljkeList([],[]);
            
                            }

                            if(response.data.info5 && response.data.info5.length!=0){
                                var dataTmp = response.data;
                
                                
                
                
                
                
                                let columns= Object.getOwnPropertyNames(dataTmp.info5[0]).map((column,index)=>{
                                        return(
                                            {
                                                "field": column,
                                                "getRowId": index
                                            }
                                        )
                                    })
                                    let rows =dataTmp.info5.map((item, index)=> {
                                        return({...item,id:index})
                                    })
 
                                    
                                                                                   const updatedColumns = columns.map((col) => {


                    if(col.field == 'Datum_spisak'){
                    

                      return {
                          ...col,
                          valueFormatter: ({ value }) => {
                            if (value) {
                              
                             
                              let date = new Date(value);


                              //return date.toLocaleDateString("DD.MM.YYYY"); // Format as MM/DD/YYYY (or customize)
                              const options = {
                               
                                  year: "numeric",
                                  month: "numeric",
                                  day: "numeric",
                                };
                                return date.toLocaleDateString("hr-HR", options);
                              
                             
                            }
                            return value;
                          },
                          sortComparator: (v1, v2) => {
                            const date1 = new Date(v1);
                            const date2 = new Date(v2);
                            return date1 - date2; // Compare dates
                          },
                        };
                      

                    }

                    if(col.field == 'Datum_izvora'){
                    

                      return {
                          ...col,
                          valueFormatter: ({ value }) => {
                            if (value) {
                              
                             
                              let date = new Date(value);


                              //return date.toLocaleDateString("DD.MM.YYYY"); // Format as MM/DD/YYYY (or customize)
                              const options = {
                               
                                  year: "numeric",
                                  month: "numeric",
                                  day: "numeric",
                                };
                                return date.toLocaleDateString("hr-HR", options);
                              
                             
                            }
                            return value;
                          },
                          sortComparator: (v1, v2) => {
                            const date1 = new Date(v1);
                            const date2 = new Date(v2);
                            return date1 - date2; // Compare dates
                          },
                        };
                      

                    }

                    return col;
              });


                  //columns = updatedColumns;
                columns =  [
                    ...updatedColumns
                ];
                
                                    setArhivaList({
                                        columns,
                                        rows
                                    })
    
                                    console.log("Set the posiljkeList");
                                  
                
                
                
                
                           
                                }else{
                
                                        setArhivaList([],[]);
                
                                }
        }
        
    
    }).catch(error=> {
            
            console.log(error);


            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                toastError);                    

        
    })
}


  return (
    <Box theme={theme} 

    >

        <div className="BijeleStranice-main-container"  
        //style={{resize: modalIsOpen ? "both" : "unset",width: modalIsOpen ? "1100px" : "100%", height: modalIsOpen ? "400px" : ""}} 

       
         >
        <div className={`BijeleStranice-header`} 
                   
              

            >

                    <div className="BijeleStranice-header-title">
                        <Typography  className="BijeleStranice-header-title-text" variant="h5">
                            Val - Analiza telefona
                        </Typography>

                    </div>

        </div>
            
        <div className="BijeleStranice-body">
                <div className="BijeleStranice-form">
                        <div className="BijeleStranice-form-third-part">

                                <Grid sx={{padding:'5px', gap:"5px", minWidth: "90%"}} container spacing={0.75} columns={{xs:12}}>

                                    <Grid xs={12} sx={{padding:'5px', gap:"0px", marginBottom: '20px'}} container spacing={0.75} >
                                                                
                                        <Grid xs={8}>
                                            <TextField
                                                InputProps={{sx:{height:30}}}
                                                InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px",
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                    }
                                                    }}
                                                                            size="small"
                                                                            fullWidth
                                                                            id=""
                                                                            label="Telefon"
                                                                            variant="outlined"
                                                                            value={tel}
                                                                            
                                                                            onChange={(event) => {

                                                                                    console.log(event);
                                                                                    console.log(event.target.value);
                                                                                    setTel(event.target.value);
                                                                                
                                                                            }}
                                                                            onKeyDown={(event) => {
                                                                                if (event.key === 'Enter'){
                                                                                    console.log('Enter Pressed')
                                                                                    console.log(tel);
                                                                                    getAnalizaTel(tel);
                                                                                }
                                                                            }}
                                                                        />
                                        </Grid>

                                        <Grid xs={4}>
                                        <Button sx={{height:"30px", fontSize:"10px"}} variant="contained" color="primary"
                                                        onClick={() => {
                                                                if(tel && tel != ''){

                                                                    console.log("Tražim: " + tel);

                                                                    getAnalizaTel(tel);

                                                                } else {

                                                                    console.log("Prazan tel");
                                                                    toast.error("Morate upisati broj telefona za pretragu", toastError);
                                                                }
                                                    }}>
                                                    Traži
                                                </Button>
                                            </Grid>

                                    </Grid>

                                    <Divider />

                                    <Grid xs={12}>
                                         <TextField
                                                InputProps={{sx:{height:30}}}
                                                InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px",
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                    }
                                                    }}
                                                                            size="small"
                                                                            fullWidth
                                                                            id=""
                                                                            value={bureInfo}
                                                                            label="Trenutno stanje"
                                                                            variant="outlined"
                                                                        
                                                                            disabled
                                                                            onChange={(event) => {
                                                                                
                                                                            }}
                                                                        />

                
                                    </Grid>
                                                                    

                                                                    
                
                                </Grid>        

                        </div>  

         

                    <div className="BijeleStranice-form-second-part" 
                        style={{display:arhivaList.rows? "flex":"none", flexDirection:'column', alignItems:'flex-start', 
                            justifyContent:'flex-start', marginTop:'20px'}}
                    >


                        <div style={{fontSize: '1em', fontWeight: 'bold'}}>Arhiva</div>                                                                


                        {arhivaList.rows &&  <div style={{ width: "100%", height:"150px" , marginTop:10}}>  
                            <AgGridReact
                                rowData={arhivaList.rows}
                                columnDefs={arhivaList.columns}

                            
                                ref={gridRef_arh}
                                theme={themeAG}
                            
                                autoSizeStrategy={autoSizeStrategy_arh}
                                onGridReady={onGridReady_arh}
                                onColumnResized={onColumnResized_arh}

                            
                        
                                onRowSelected={onRowSelected_arh}
                                onSelectionChanged={onSelectionChanged_arh}

                        /></div> }


                                
                    </div>          

                   

                    <div className="BijeleStranice-form-second-part" 
                    style={{display:journalList.rows? "flex":"none" , flexDirection:'column', alignItems:'flex-start', 
                            justifyContent:'flex-start', marginTop:'20px'}}
                    >


                        <div style={{fontSize: '1em', fontWeight: 'bold'}}>Journal</div> 

                            {journalList.rows &&  <div style={{ width: "100%", height:"150px" , marginTop:10}}>  
                                <AgGridReact
                                    rowData={journalList.rows}
                                    columnDefs={journalList.columns}

                                
                                    ref={gridRef_jn}
                                    theme={themeAG}
                                
                                    autoSizeStrategy={autoSizeStrategy_jn}
                                    onGridReady={onGridReady_jn}
                                    onColumnResized={onColumnResized_jn}

                                
                            
                                    onRowSelected={onRowSelected_jn}
                                    onSelectionChanged={onSelectionChanged_jn}

                            /></div> }


            
                                       
                    </div>          



                    <div className="BijeleStranice-form-second-part" 
                    style={{display:posiljkeList.rows? "flex":"none", flexDirection:'column', alignItems:'flex-start', 
                        justifyContent:'flex-start', marginTop:'20px'}}
                >


                    <div style={{fontSize: '1em', fontWeight: 'bold'}}>Pošiljke</div> 

                            {posiljkeList.rows &&  
                            <div style={{ width: "100%", height:"150px" , marginTop:10}}>   
                                <AgGridReact
                                    rowData={posiljkeList.rows}
                                    columnDefs={posiljkeList.columns}

                                
                                    ref={gridRef}
                                    theme={themeAG}
                                
                                    autoSizeStrategy={autoSizeStrategy}
                                    onGridReady={onGridReady}
                                    onColumnResized={onColumnResized}

                                
                            
                                    onRowSelected={onRowSelected}
                                    onSelectionChanged={onSelectionChanged}

                            /></div> 
                            }


                                       
                    </div>            
                   
                  

                    <div className="BijeleStranice-form-second-part" 
                    style={{display:bzList.rows? "flex":"none" , flexDirection:'column', alignItems:'flex-start', 
                        justifyContent:'flex-start', marginTop:'20px'}}
                >


                    <div style={{fontSize: '1em', fontWeight: 'bold'}}>Bijele/Žute stranice</div> 


                        {bzList.rows &&  <div style={{ width: "100%", height:"150px" , marginTop:10, marginBottom: 10}}>  
                            <AgGridReact
                                rowData={bzList.rows}
                                columnDefs={bzList.columns}

                            
                                ref={gridRef_bz}
                                theme={themeAG}
                            
                                autoSizeStrategy={autoSizeStrategy_bz}
                                onGridReady={onGridReady_bz}
                                onColumnResized={onColumnResized_bz}

                            
                        
                                onRowSelected={onRowSelected_bz}
                                onSelectionChanged={onSelectionChanged_bz}

                        /></div> }


                                
                    </div>       

                    </div>    


       
            </div>


        </div>
    </Box >
  );
}

export default Analiza;
